import styled from "styled-components";
import { CoverImage } from "p6-react-shared";
import DesignConstants from "../../../constants/DesignConstants";

// flex-grow only works when the parent TestCreationHeader gets hasFullHeightContent —
// pushes the sticky CTA footer to the bottom instead of overlapping the last item.
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};
    flex: 1 0 auto;
`;

export const CTASWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column;
    }
`;

export const MiddleContentWrapper = styled.div`
    flex: 1;
    width: 100%;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        display: flex;
        flex-direction: column;
    }
`;

export const SelectsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 1.5rem;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-wrap: wrap;
        flex-direction: column;
        gap: 0.5rem;
    }

    input {
        border-radius: 50px;
        color: #666666;
    }
`;

export const SmallSelectWrapper = styled.div`
    flex: 1;

    input {
        color: black;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        width: 100%;
    }
`;

export const BookSearchSelectWrapper = styled.div`
    flex: 2;

    input {
        color: black;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        width: 100%;
    }
`;

export const SelectedContentWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    height: calc(100% - 80px);
    width: 100%;

    > div {
        width: 100%;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        max-height: 100%;
        height: auto;
    }
`;

export const BookImageWrapper = styled.div`
    width: auto;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
`;

export const BookNameWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
`;

export const StyledCoverImage = styled(CoverImage)`
    width: unset !important;
    height: 150px !important;
`;

export const TestToText = styled.p`
    font-size: 0.9rem;
`;

export const BookName = styled.h4`
    font-weight: bold;
    margin: 0.5rem 1rem 0 0;
`;
